module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-netlify-cms/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-helmet-async/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-omni-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"enableListener":true,"preconnect":["https://fonts.googleapis.com","https://fonts.gstatic.com","https://use.typekit.net"],"web":[{"name":"Just Another Hand","file":"https://fonts.googleapis.com/css2?family=Just+Another+Hand&display=swap"},{"name":"Quicksand","file":"https://fonts.googleapis.com/css2?family=Quicksand:wght@300..700&display=swap"},{"name":"urw-din","file":"https://use.typekit.net/ney7bcg.css"}],"options":{"typekit":{"id":"ney7bcg"}}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Bladder Cancer Answers","short_name":"BCA","start_url":"/","background_color":"#1F99D2","theme_color":"#2E348D","display":"standalone","icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"c64a5dc58867cb2785e682bb0883f602"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
